import { inputModeType } from 'lib/util'
import { FILTER_USER_MAP } from './constants'
import { FILTER_CONFIG } from './data'

export const handleFilterSiteUsers = (
  event,
  { site, pushTo, setSelectedFilterOption },
) => {
  const filterKey = event?.key || event
  const config = FILTER_CONFIG[filterKey]

  if (!config || !site?.id) return

  const siteUrl = `/user-management/${site.id}`
  setSelectedFilterOption({
    key: filterKey,
    name: FILTER_USER_MAP[filterKey],
  })
  pushTo(`${siteUrl}${config.query}`)
}

export const handleSendInvites = (
  { all, pending, ...roles },
  { site, remindSiteUsers, setSendInvitesModalOpen },
) => {
  if (!site?.id) return

  const sendInvObj = { pendingUsers: !!pending }

  if (!all && !pending && Object.values(roles).every(role => !role)) {
    setSendInvitesModalOpen(false)
    return
  }

  if (all || pending) {
    remindSiteUsers(site.id, sendInvObj)
    setSendInvitesModalOpen(false)
    return
  }

  const sendToRoles = Object.entries(roles)
    .filter(([role, value]) => value && role !== 'all' && role !== 'pending')
    .map(([role]) =>
      role === 'leaderTeam'
        ? 'Leader Team'
        : `${role.charAt(0).toUpperCase()}${role.slice(1)}`,
    )

  if (sendToRoles.length > 0) {
    sendInvObj.roles = sendToRoles
  }

  remindSiteUsers(site.id, sendInvObj)
  setSendInvitesModalOpen(false)
}

export const handleSubmitAddUsers = async (
  emails,
  role,
  sendNotification,
  inputMode,
  {
    siteId,
    site,
    createSiteUsers,
    createSiteUser,
    resetBulkAddUsers,
    setIsAddUserModalOpen,
  },
) => {
  if (!siteId) return

  const addSiteUsers = emails.map(email => ({
    inviteEmail: email?.trim(),
    isActive: true,
    roles: [role],
    siteId,
  }))

  if (inputMode === inputModeType.bulk) {
    await createSiteUsers(siteId, addSiteUsers, sendNotification)
  } else {
    await createSiteUser(addSiteUsers[0], sendNotification, site)
    resetBulkAddUsers()
    setIsAddUserModalOpen(false)
  }
}
